import { render, staticRenderFns } from "./ParticipantSidebar.vue?vue&type=template&id=5d2e71b3"
import script from "./ParticipantSidebar.vue?vue&type=script&lang=js"
export * from "./ParticipantSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports